import { z } from 'zod'

const id = z.string().min(1)

/** 운영 정책 `home`(어드민 홈 구성)을 서버가 계산한 결과 — 칸의 workIds 는 고정 · 제외 · 개수까지 적용된 최종 순서 */
const homeSectionSchema = z.object({
  id,
  source: z.enum(['manual', 'official', 'chats', 'likes', 'new', 'all']),
  title: z.string().optional(),
  sub: z.string().optional(),
  ranked: z.boolean().optional(),
  workIds: z.array(id).default([]),
})

/** 작품 내용은 buildLiveCatalog 가 작품별로 검사해 깨진 필드만 걸러 낸다 — 여기서 작품 하나 때문에 홈 전체를 버리지 않는다 */
export const homeCatalogSchema = z.looseObject({
  works: z.array(z.looseObject({ id })),
  config: z.looseObject({
    home: z
      .object({
        banners: z
          .array(z.object({ workId: id, line: z.string().optional() }))
          .default([]),
        sections: z.array(homeSectionSchema).optional(),
        workIds: z.array(id).default([]),
      })
      .optional(),
  }),
})

export type HomeSection = z.infer<typeof homeSectionSchema>
type HomeBannerConfig = { workId: string; line?: string }
export type HomeView = {
  banners: HomeBannerConfig[]
  sections: HomeSection[]
  works: z.infer<typeof homeCatalogSchema>['works']
}
